export default __webpack_public_path__ + "static/media/WorkSans-Regular.d9d9192d.eot";